var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 15.857A5.143 5.143 0 0 1 8.143 21M3 11.571A9.429 9.429 0 0 1 12.429 21M3 7.286c7.574 0 13.714 6.14 13.714 13.714M3 3c9.941 0 18 8.059 18 18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogLine);
export default __webpack_public_path__ + "static/media/blog_line.14c2df09d6bbd092a53194b4230b6c3b.svg";
export { ForwardRef as ReactComponent };